const It = {
    "网络错误": "Errore di rete",
    "目前没有订单": "Nessun ordine attuale",
    "请联系客服解冻": "Si prega di contattare il servizio clienti per averlo scongelato.",
    "提交订单": "Invia ordine",
    "已提交": "Inviato",
    "待提交": "Invio in sospeso",
    "余额不足，差额100": "Congratulazioni: hai ricevuto un ordine fortunato. Contatta la tua referente dedicata.",
    "操作成功": "Operazione riuscita",
    "订单错误": "Errore dell'ordine",
    "参数错误": "Errore del parametro",
    "获取成功": "Successo",
    "抢单失败": "Tentativo di rapina fallito",
    "抢单完成": "Elaborazione ordine completata",
    "没有订单数，请联系客服": "Non c'è quantità d'ordine. Si prega di contattare il servizio clienti.",
    "抓取订单最小金额100": "Importo minimo dell'ordine 100 acquisisce",
    "此帐户中有未完成的订单，您无法继续抓取订单": "Non puoi continuare a acquisire ordini perché ci sono ordini non completati sotto questo account.",
    "完成订单还需额外支付100": "Un costo aggiuntivo di 100 si applica al completamento dell'ordine.",
    "幸运订单": "Congratulazioni: hai ricevuto un ordine fortunato",
    "加载中": "Caricamento",
    "订单详情": "Dettagli ordine",
    "评估": "Valutazione",
    "订单号": "Numero dell'ordine",
    "抢单时间": "Orario dell'ordine",
    "总金额": "Importo totale",
    "订单历史记录": "Cronologia ordini",
    "开始接受订单": "Iniziare a prendere ordini",
    "今天佣金": "La commissione di oggi",
    "差额": "Differenza",
    "未完成": "Incompleto",
    "已完成": "Completato",
    "剩余次数": "Numero degli ordini",
    "佣金": "Commissione",
    "账户资金": "Fondi del conto",
    "冻结金额": "Quantità congelata",
    "总收入": "Totale entrate",
    "请输入充值金额": "Inserisci l'importo dell'addebito.",
    "可用余额": "Saldo disponibile",
    "邀请代码": "Codice di rinvio",
    "赌注金额": "Importo scommesse",
    "每次3分钟": "3 minuti per episodio",
    "用户": "Utente",
    "电影": "film",
    "开卡记录": "Cronologia di apertura della carta",
    "累计收益": "Interessi attivi accumulati",
    "今日收益": "Il profitto di oggi",
    "我的余额": "Il mio saldo",
    "恭喜": "Congratulazioni!",
    "开卡成功": "Attivazione della carta riuscita",
    "你好": "Ciao.",
    "家": "Home",
    "订单": "Ordine",
    "返回登录": "Torna alla schermata di login",
    "畅销书": "Bestseller",
    "共享购物": "Condividi shopping",
    "会员页面": "Pagina del membro",
    "银行兑换不存在": "Lo scambio bancario non esiste.",
    "请选择银行兑换": "Seleziona lo scambio bancario.",
    "银行兑换": "Ufficio di cambio della banca",
    "正在连接": "Connessione",
    "已连接": "Connesso",
    "规格": "Specifiche",
    "购买单类型": "Tipo di ordine di acquisto",
    "期数": "Conteggio del periodo",
    "投注号码": "Numero di scommesse",
    "订单时间": "Orario dell'ordine",
    "大": "A",
    "小": "B",
    "单": "C",
    "双": "D",
    "连接代码": "Codice di connessione",
    "单个连接数": "Conteggio connessione singola",
    "未连接": "Non connesso",
    "连接金额": "Quantità di cavo di collegamento",
    "项目历史": "Storia del progetto",
    "命中命令": "Vittoria del nuovo ordine",
    "下订单": "Ordine",
    "注意": "Registra l'incidente.",
    "账户余额": "Piastra della bilancia del conto",
    "限制每天的次数": "Limite di tempo giornaliero",
    "无限制": "Nessun limite di gare",
    "提款时间": "Tempo di scrittura",
    "每天限制金额": "Offerta in quantità limitata per un giorno",
    "鉴权错误": "Accedi",
    "请登录您的帐户": "Accedi al tuo account.",
    "注册帐户": "Registrazione account",
    "账户": "È un conto.",
    "密码": "Password per il controllo della password",
    "创建您的帐户": "Crea account",
    "验证密码": "Conferma password",
    "请重新输入密码": "Inserisci di nuovo la tua password.",
    "重新输入密码不正确": "Impossibile inserire nuovamente la password.",
    "二级密码": "Livello di password 2",
    "请输入付款密码": "Inserisci la tua password di pagamento.",
    "二级密码验证": "Conferma il livello della password 2",
    "二级密码不一致": "La password di grado 2 non corrisponde.",
    "邀请码": "Codice invito",
    "提款编号": "Numero di tentativi di tracciamento della spedizione",
    "搜索": "Cerca Nikon",
    "流行的": "È molto popolare.",
    "历史": "È storia.",
    "存款": "Caricamento e caricamento",
    "提款": "Prelevare contanti",
    "项目列表": "Elenco progetti",
    "代码": "Targa con codice posteriore",
    "正在合并": "Iscriviti ora",
    "代码结果": "Risultato del numero di codice",
    "输入分数": "Inserisci il conteggio dei punti",
    "分数": "Numero di punti",
    "转换点数": "Numero di punti di rimborso",
    "发送": "Mandalo.",
    "注意：请输入正确的转账内容，转账成功后请联系客户服务。": "Nota: inserisci i dettagli del bonifico bancario corretti e contatta il servizio clienti dopo aver completato con successo il trasferimento.",
    "账号": "Numero di conto",
    "账户持有人": "Proprietario dell'account",
    "银行名称": "Nome della banca",
    "复制成功": "Copia fallita",
    "提交成功": "Inviato con successo",
    "请输入银行名称": "Inserisci il nome della banca.",
    "请使用英文字母表示用户名。": "Usa i caratteri inglesi per riflettere il tuo nome utente.",
    "请输入您的账号": "Inserisci il tuo numero di conto.",
    "成员中心": "Hub membri",
    "变化": "Vibrazione della valvola",
    "VIP级别": "VIP salire di livello",
    "等级荣誉": "Scatola del segno del distintivo dell'emblema",
    "等级": "Piastra di livello 1",
    "图标": "Scatola logo distintivo emblema",
    "名称": "Nome e cognome",
    "充值历史": "Cronologia della ricarica",
    "提款历史": "Cronologia dei prelievi",
    "我的银行卡": "La mia carta bancaria",
    "登录密码": "Accesso alla password",
    "交易密码": "Codice di transazione",
    "旧密码": "Vecchia password",
    "新密码": "Nuova password",
    "请输入旧密码": "Inserisci la tua password precedente.",
    "请输入新密码": "Inserisci una nuova password.",
    "消息管理": "Gestione dei messaggi",
    "注销": "Record",
    "请输入资金密码": "Inserisci la password del tuo fondo.",
    "禁止下注": "Scommesse vietate",
    "choose_msg": "Siete pregati di contattare la reception o un membro del personale per assistenza.",
    "取消": "Annulla",
    "确定": "Decisione",
    "请选择银行": "Seleziona una banca.",
    "分钟": "Sezione",
    "互动历史": "Storia interattiva",
    "钱": "Soldi",
    "此帐户已冻结，请联系客户服务": "Questo account è congelato. Si prega di contattare il servizio clienti.",
    text: {
        txt37: "Resoconto delle votazioni",
        choose: "corrispondenza",
        bond: "Verificato e pagato un deposito di $ 10000",
        img: "Rappresentazione verticale",
        intention: "Tolleranza del piede",
        casual: "Istruzioni per il sesso casuale",
        txt1: "Nota: Questa piattaforma fornisce i prodotti più autentici del gancio e del loop del trasporto aereo. Per proteggere la privacy degli utenti, l'iscrizione richiede di contattare il servizio clienti o raccomandato da individui di successo.",
        txt2: "Consulenza al servizio clienti",
        txt3: "guida",
        txt4: "Scrivi il numero di tua sorella e contatta il servizio clienti",
        ok: "OK",
        cancel: "annulla",
        txt5: "A beneficio di tutti i membri, solo l'1% delle risorse viene visualizzato sul sito e gli aggiornamenti sono irregolari. Per informazioni dettagliate, contattare il servizio clienti.",
        txt6: "Tutte le informazioni sui membri sulla piattaforma sono autentiche, sicure e affidabili. Può essere utilizzato a livello nazionale, e nuovi incontri possono essere trovati anche sulla stessa strada. Scegli una donna che ti piace e incontrarla di persona. Unisciti ora~",
        txt7: "Informazioni sui membri",
        txt8: "corrispondenza",
        txt9: "Usa il protocollo",
        txt10: "Voglio uscire con lei.",
        txt11: "Questa piattaforma fornisce la ricerca più autentica della deflazione. Per proteggere la privacy delle informazioni personali, la registrazione può essere effettuata solo contattando il supporto o accettando raccomandazioni di nome reale da parte di individui che hanno cercato con successo l'esperienza di deflazione.",
        txt12: "Attualmente 0 accoppiamenti online",
        txt13: "44 attivazione",
        txt14: "Prestazioni per i membri",
        txt15: "evento",
        txt16: "Video membro",
        txt17: "Mentigli",
        txt18: "Informazioni sui membri",
        txt19: "Nuovo ID",
        txt20: "incontro",
        txt21: "La votazione termina",
        txt22: "Risultati del periodo",
        txt23: "periodo",
        txt24: "Seleziona casualmente il numero",
        credit_score: "Punteggio di credito",
        mail: "Lettera stazione",
        txt25: "L'aggiornamento richiede 15 punti percentuali",
        txt26: "Punti personali",
        txt27: "Punto ( 8361;)",
        txt28: "Ricarica punti",
        txt29: "Cambia la posizione",
        txt30: "servizio online",
        txt31: "breve introduzione",
        txt32: "Clicca su informazioni dettagliate",
        txt33: "Riavvia lo scambio",
        txt34: "record di dati",
        txt35: "Cambia password",
        txt36: "Cambia la posizione",
    },
    login: {
        title: "Log on", //登录
        username:"Digitate il nome dell’utente",//请输入用户名
        password:"Digitare la parola d’ordine",//请输入密码
        forgetPaw:"Dimenticate le password",//忘记密码
        registerNow:"Nessun conto? Registrazione immediata",//没有账户？马上注册
        doLogin:"Log on",//登录

    },
    register:{
        title: "registrazione", //注册
        username:"Indicare il nome dell’utilizzatore (6-12 lettere o cifre)",//请输入用户名(6-12个英文字母或数字)
        password:"Digitare la parola d’accesso (6-12 lettere o cifre).",//请输入登录密码(6-12个英文字母或数字)
        code:"Digitare il codice di invito",//请输入邀请码
        agreement:"Conosco già i trattati e li condivido",//我已经知晓并同意"开户协议"各项条约
        chooseAgreement:"Spunta un accordo di apertura di un conto!",//请勾选下方开户协议！
        doRegister:"registrazione",//注册
    },
    footer:{
        home :"pagina",//首页
        game:"appuntamento",//预约
        video:"video",//视频
        mine:"La mia",//我的
    },
    game:{
        title:"Locali riservati",//预约大厅
        all:"totale",//全部
    },
    choose:{
        title:"XuanFei",//选妃
        city:"Città grande",//城市大全
        rule:"Per garantire la privacy personale di ogni utente, i clienti possono aderire solo contattando l’addetto al ricevimento o fornendo il nome completo del membro più anziano della piattaforma.",//本平台全网最真实外围+商务伴游+同城激情，为保证每个用户的个人隐私，客户仅限通过联系接待员或平台资深会员实名推荐才可加入。
        price:"Evoluzione dei prezzi",//价格流程
        resource:"Quali sono le risorse disponibili?",//有哪些资源?
        character:"Cyber red, modelle, hostess di volo, unmh, studenti universitari, non potete immaginarvelo. Non potete farlo senza questa piattaforma",//网红、模特、空姐、嫩模、大学生，只有您想不到，没有本平台办不到
        scope:"Gamma dei servizi?",//服务范围?
        location:"Le città gemellate sono libere di volare in qualsiasi punto del paese, sono presenti nella zona urbana domestica di primo e secondo livello e le città di terzo livello possono anche prendere appuntamento con gli addetti al ricevimento.",//同城免费约炮，任意地点全国空降，国内一二线城市当地均有，三线城市也可通过联系接待员预约安排。
    },
    home:{
        recommend:"Missione raccomandata",//推荐任务
        more:"Per saperne di più",//查看更多
        popularity:"Buona compagnia",//人气排行
        hot:"Raccomandazione di conclusione",//热门推荐
    },
    lottery:{
        jieguo: "Risultato della votazione",
        jiesu: "& Fine",
        record:"Registrazione delle attività",//任务记录
        rule:"Le regole del gioco",//玩法规则
        prompt:"Metodi di calcolo",//玩法提示
        gameplay:"Scegliere i numeri all’interno della formula facoltativa e di valore per le scommesse",//从可选和值形态里面选择号码进行下注
        explain:"Descrizione delle vincite",//中奖说明
        wprole:"La somma dei tre numeri iniziali, da 11 a 18, è grande; I valori della somma da 3 a 10 sono piccoli;",//三个开奖号码总和值11~18 为大;总和值3~ 10为小;
        example:"Esempi di rischi",//投注范例
        option:"Sistema di partecipazione: numero iniziale: 123, cioè piccole e medie imprese",//投注方案：小 开奖号码：123,即中小
        task:"Elenco dei compiti",//任务单
        money:"Saldo disponibile",//可用余额
        submit:"presentazione",//提交
        selection:"Attuali numeri di catalogo",//当前选号
        perNote:"Importo per nota",//每注金额
        inputMoney:"Indicare l’importo",//请输入金额
        total:"totale",//总共
        note:"totale",//总共
        statistics:"totale",//合计
        empty:"Ordine di cancellazione",//清空订单
        verify:"Conferma di trasmissione",//确认提交
        issue:"Periodo di n.",//期号
        num:"Numero di lancio",//开奖号码
        big:"grandi",//大
        small:"piccolo",//小
        single:"mono",//单
        double:"doppio",//双
        unselected:"Nessuna selezione",//未选择
        drawLottery:"Il premio è stato assegnato a:",//开奖成功，期号：
        kefu:"Si prega di contattare l’amministratore per avere il compito!",//请联系管理员领取该任务!
    },
    mine:{
        recharge:"complementari",//充值
        withdraw:"ritiro",//提现
        myMoney:"Il mio portafoglio",//我的钱包
        detail:"dettagli",//详情
        balance:"saldo",//余额
        finance:"Scheda individuale",//个人报表
        order:"Particolari della contabilità",//账户明细
        record:"Registrazione delle attività",//任务记录
        my:"Centri personali",//个人中心
        notice:"Bollettino d’informazione",//信息公告
        service:"Servizio clienti online",//在线客服
        score: "I punti",
    },
    setting:{
        title:"regolazione",//设置
        basic:"Elaborazione delle informazioni di base",//基本信息设置
        password:"Parola d’accesso",//登录密码
        capital:"Codici di finanziamento",//资金密码
        lang:"lingua",//语言
        quit:"Uscita logon",//退出登录
    },
    setPayPassword: {
        title:"Stabilire il codice dei finanziamenti",//设置资金密码
        opw:"Per favore digitate il codice del finanziamento",//请输入资金密码
        tpw:"Per favore, digitate di nuovo il codice del finanziamento",//请再次输入资金密码
    },
    gameRecord:{
        reject: "respinge",
        profit: "profitto",
        place: "effettuare un ordine",
        title:"Registrazione delle attività",//任务记录
        amountBet:"Importo delle entrate",//下注金额
        create:"La prossima ora",//下单时间
        update:"Momento della liquidazione",//结算时间
    },
    video:{
        title:"Il video cinema",//视频影院
        play:"In onda",//播放
    },
    playVideo:{
        play: "sottodiffusione",//次播放
    },
    setname:{
        title:"Modifica dei nomi autentici",//修改真实姓名
        name:"nomi",//姓名
        truename:"Per piacere digitare il nome esatto",//请输入真实姓名
        hint:"Per garantire la sicurezza del proprio conto, il nome autentico deve corrispondere a quello della carta di credito consolidata",//为了您账户安全,真实姓名需要与绑定银行卡姓名一致
    },
    setsex:{
        title:"Modifica del sesso",//性别修改
    },
    bindCard:{
        title:"Compilare la carta di raccolta",//填写收款卡
        msg:"Digitate le informazioni sulla vostra carta di credito",//请输入您的收款卡信息
        hint:"Onorevoli deputati, per garantire la sicurezza del vostro denaro, vi invitiamo a rivedere il vostro vero nome e a fissare una password per il prelievo, che non sarà ottenibile se il nome non coincide con il nome di apertura di un conto",//尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款
        card: "Numero di conto (ordinario)",
        truecard: "Inserisci il numero di conto (normale)",
        name: "Nome dell'account (vero nome)",
        truename: "Inserisci il nome dell'account (vero nome)",
        financial_institution: "Nome dell'Istituzione Finanziaria",
        truefinancial_institution: "Inserisci il nome dell'istituto finanziario",
        branch: "Nome della filiale",
        truebranch: "Inserisci il nome della filiale",
        branch_number: "Numero di filiale",
        truebranch_number: "Inserisci il numero di riga"
    },
    setbank:{
        title:"Informazioni sulle carte di credito",//收款卡信息
        bank:"Aggiunta di carte bancarie",//添加银行卡
        hint:"Nb: leggete le grandi banche commerciali e, in caso di modifiche, contattate il servizio clienti online",//提示:请绑定大型商业银行,如需修改,请您联系在线客服
    },
    setLoginPassword:{
        title:"Modificare la password logon",//修改登录密码
        old_password:"Codice vecchio",//旧密码
        old_password_p:"Per favore digitate la vecchia password",//请输入旧密码
        o_new_password:"Nuove password",//新密码
        o_new_password_p:"Per favore digitate la nuova password",//请输入新密码
        t_new_password_p:"Per favore, digitate di nuovo la password",//请再次输入新密码
    },
    infomation:{
        title:"Informazioni di base",//基本信息
        head:"avatar",//头像
        select:"Scegliere il profilo",//选择头像
        name:"Nome autentico",//真实姓名
        sex:"sesso",//性别
        man:"uomo",//男
        girl:"donna",//女
        unknown:"sconosciuto",//未知
        binding:"Informazioni vincolanti",//绑定信息
    },
    withdraw: {
        title:"Centri di ritiro",//提现中心
        record:"Registrazione del ritiro",//提现记录
        money:"Importi ritirati",//提现金额
        all:"totale",//全部
        min:"Limite unico: minimo",//单笔限额：最低
        max:"massimo",//最高
        num:"Numero massimo di ritiri: massimo al giorno",//提现次数：一天最高提现
        hint:"Per quanto riguarda le scadenze di pagamento, esse sono generalmente di circa 5 minuti e sono più brevi di 2 minuti",//到账时间：一般到账时间在5分钟左右，最快2分钟内到账
        quota:"Descrizione dei limiti",//限额说明
        balance:"saldo",//余额
        withdraw:"Ritiro immediato",//马上提现
    },
    withdrawRecord:{
        desc:"descrizione",//说明
        create:"Tempo di presentazione",//提交时间
        update:"Momento della revisione",//审核时间
    },
    personalreport:{
        title:"Scheda individuale",//个人报表
        profit:"Importo utile",//盈利金额
        formula:"Formula di calcolo della redditività: importo del premio — importo della missione",//盈利计算公式 : 中奖金额 - 任务金额
        task:"Importo della missione",//任务金额
        recharge:"Importo compensativo",//充值金额
        withdrawal:"Importi ritirati",//提现金额
        win_money:"Importo della sovvenzione",//中奖金额
    },
    service: {
        title:"Servizio clienti online",//在线客服
        relation:"contatti",//联系
        hint:"24 ore e mezzo",//全天7 * 24小时竭诚为您服务
    },
    msg:{
        "账号被禁用！": "Account disabilitato!",
        "次":"tempi",
        "用户不存在！":"Gli utenti non esistono!",//用户不存在！
        "密码错误！":"Errore di password!",
        "登录成功！":"Un successo!",
        "邀请码不存在！":"I codici di invito non esistono!",
        "用户名位数错误！":"Errore di nome utente!",
        "密码位数错误！":"Errore di numero d’ordine!",
        "用户名不能存在中文！":"Il nome utente non può esistere in cinese!",
        "邀请码不能为空！":"Il codice di invito non deve restare vuoto!",
        "注册成功！":"Registrazione: successo!",
        "注册失败！":"Mancata registrazione!",
        "用户已存在":"Gli utenti già esistenti",
        "刷新成功！":"Lavatevi un nuovo successo!",
        "请联系顾问或接待员":"Si prega di contattare un consulente o una reception",
        "金额错误！":"Gli importi sono sbagliati!",
        "请选号！":"Indicare il numero",
        "请填写金额!":"Indicare l’importo!",
        "余额不足，请联系客服充值！":"Saldo insufficiente, per favore contattate il servizio clienti!",
        "没有更多了":"Niente di più",
        "没有数据":"Dati non disponibili",
        "余额不足！":"Saldo insufficiente!",
        "扣款失败！":"Non si pagano!",
        "下注异常！":"Scommettere!",
        "投注成功！":"La scommessa ha successo!",
        "参数异常！":"Anomalie di parametri!",
        "获取中":"Accesso …",
        "请完成任务单后进入":"Per piacere entri dopo aver terminato il suo ordine di missione",
        "请联系客服充值":"Si prega di contattare il servizio assistenza clienti",
        "请设置收款卡!":"Per favore, create una carta di raccolta!",
        "功能已禁用!":"La funzione non funziona più!",
        "账号下线":"I numeri dei conti scendono",
        "登录/注册":"Logon/registrazione",
        "登录可享受更多服务！":"Più servizi per collegarsi!",
        "未设置":"Non stabilito",
        "已设置":"Già stabilito",
        "提交":"presentazione",
        "确定":"definire",
        "请填写完整":"Vogliate compilare l’elenco completo",
        "两次密码不一致！":"Due volte la password non è coerente!",
        "设置提现密码成功！":"Fatevi avanti con il password proposto!",
        "提现密码已设置，需要修改请联系客服":"Il password di partenza è stato stabilito e richiede una modifica del vostro abbigliamento",
        "已绑定":"Impegni sottoscritti",
        "无":"senza",
        "更换头像成功！":"Sostituire le teste ha successo!",
        "更新头像失败！":"Aggiornare l’anteprima è un fallimento!",
        "请勿重复设置！":"Non ripetere!",
        "设置姓名成功！":"Il nome è un successo!",
        "设置姓名失败！":"Non è riuscito a definire il nome!",
        "设置性别成功！":"Un successo sul genere!",
        "设置性别失败！":"Un fallimento di genere!",
        "请设置姓名后再绑定银行卡！":"Per favore, leggete la carta bancaria dopo il vostro nome!",
        "请设置提现密码后再绑定银行卡！":"Per favore, decidete la password e leggete la carta bancaria dopo averla ritirata!",
        "确认绑卡":"Riconoscimento della carta di collegamento",
        "请输入银行卡号！":"Per favore scrivi il numero della carta bancaria!",
        "请输入银行名称！":"Per favore scrivi il nome della banca!",
        "设置银行卡成功！":"Il successo della carta bancaria!",
        "设置银行卡失败！":"Il fallimento della carta bancaria!",
        "旧密码错误":"Vecchi errori di password",
        "修改密码成功！":"Cambiare password: successo!",
        "修改密码失败！":"Mancata revisione della password!",
        "请填写正确的金额":"Per favore scrivi l’importo giusto",
        "提现金额不能少于：":"L’importo del ritiro non può essere inferiore a:",
        "提现金额不能大于：":"L’importo del ritiro non può essere superiore a:",
        "当日提现次数已用完":"Il numero di ritiri in giornata è stato esaurito",
        "提现成功！":"Il ritiro è un successo!",
        "提现失败！":"Il ritiro è fallito!",
        "金额":"l’importo",
        "待审核":"Da esaminare",
        "审核成功":"Il successo dell’audit",
        "审核退回":"Esame della restituzione",
        "请充值后观看视频！":"Per favore, basta guardare il video!",
        "释放即可刷新":"Il rilascio può essere modificato …",
        "加载中":"Carico …",
        "下拉即可刷新": "Pulsare per aggiornare...",
    },
    setLang:{
        title:"Stabilire le lingue"
    },
    profile: {
        portrait: "Fotografia",
        video: "Video",
        jianjie: "Profilo personale",
        liji: "Prenota ora",
        chongdan: "Intervallo di ricarica",
        fd: "Signora.",
        yuyue: "Appuntamento",
        archives: "Archivio della sorella",
        age: "Età",
        height: "Altezza",
        weight: "Peso corporeo",
        cup: "La coppa di copertura",
        city: "La città",
        area: "Aree di servizio",
        item: "Articoli di servizio"
    },
    lang:{
        "zh": "Cinese",
        "jp": "Giappone",
        "ara": "Lingua:",
        "en": "Italiano",
        "spa": "Spagnolo",
        "it": "Italiano-Italiano",
        "de": "Tedesco",
        "pt": "La lingua portoghese",
        "fra": "In francese",
        "nl": "La lingua olandese",
        "id": "Indonesiano",
        "hi": "La lingua hindi",
        "kor": "Coreano",
        "tr": "La lingua turca",
        "swe": "La lingua svedese",
        "ga": "Lingua irlandese",
        "ru": "Russo",
        "vie": "La lingua vietnamita",
        th: "La lingua tailandese",
        est: "La lingua estone",
        be: "La lingua bielorussa",
        bul: "La lingua bulgara",
        pl: "La lingua polacca",
        ms: "La lingua malese",
    }
}
export default  It
